import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../lib/api";
import Seo, { docExcerpt } from "../components/Seo";

const inline = (text) => {
  // bold **...** → <strong>
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((p, i) =>
    p.startsWith("**") && p.endsWith("**") ? <strong key={`b${i}-${p}`}>{p.slice(2, -2)}</strong> : <span key={`t${i}-${p}`}>{p}</span>
  );
};

export const LegalDoc = ({ body }) => {
  const lines = (body || "").split("\n");
  const blocks = [];
  let list = [];
  const flush = () => {
    if (list.length) {
      blocks.push(<ul key={`ul-${blocks.length}`} className="list-disc ps-6 space-y-1.5 my-3">{list}</ul>);
      list = [];
    }
  };
  lines.forEach((raw, i) => {
    const line = raw.trimEnd();
    if (!line.trim()) { flush(); return; }
    if (line.startsWith("## ")) {
      flush();
      blocks.push(<h2 key={`h${i}-${line.slice(3, 24)}`} className="font-display text-xl lg:text-2xl text-ink mt-8 mb-3">{inline(line.slice(3))}</h2>);
    } else if (line.startsWith("- ")) {
      list.push(<li key={`li${i}-${line.slice(2, 24)}`} className="text-charcoal">{inline(line.slice(2))}</li>);
    } else {
      flush();
      blocks.push(<p key={`p${i}-${line.slice(0, 24)}`} className="text-charcoal leading-relaxed my-2">{inline(line)}</p>);
    }
  });
  flush();
  return <div>{blocks}</div>;
};

export default function LegalPage({ slug }) {
  const { locale = "en" } = useParams();
  const [doc, setDoc] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    setDoc(null); setError("");
    api.get(`/legal/document/${slug}`, { params: { locale } })
      .then((r) => setDoc(r.data))
      .catch(() => setError("This document could not be loaded."));
  }, [slug, locale]);

  return (
    <div className="max-w-3xl mx-auto px-6 py-16 lg:py-24" data-testid={`legal-page-${slug}`} dir={locale === "ar" ? "rtl" : "ltr"}>
      <Seo title={`${doc?.title || "Legal"} | Fleurinelle`} description={docExcerpt(doc?.body)} path={`/${locale}/${slug}`} type="article" />
      {error ? <p className="text-muted" data-testid="legal-error">{error}</p> : null}
      {doc ? (
        <>
          <h1 className="font-display text-3xl lg:text-4xl text-ink" data-testid="legal-title">{doc.title}</h1>
          {doc.effective_date ? (
            <p className="text-xs text-muted mt-2 mb-6">Version {doc.version} · {doc.effective_date}</p>
          ) : null}
          <LegalDoc body={doc.body} />
        </>
      ) : (!error ? <p className="text-muted">…</p> : null)}
    </div>
  );
}
